import { render, staticRenderFns } from "./SubjectChangeAgreement.vue?vue&type=template&id=7c70e429&scoped=true&"
import script from "./SubjectChangeAgreement.vue?vue&type=script&lang=js&"
export * from "./SubjectChangeAgreement.vue?vue&type=script&lang=js&"
import style0 from "./SubjectChangeAgreement.vue?vue&type=style&index=0&id=7c70e429&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c70e429",
  null
  
)

export default component.exports